import React, { FC, useMemo } from 'react';
import { InspectionDamage } from '@/types';
import { CustomColumns, CustomTable } from '@/ui/components';
import { CarAreaCode } from '@/utils/constants';

interface FprDataGridProps {
  areaCode?: CarAreaCode;
  dataSource: InspectionDamage[];
}
export const FprDataGrid: FC<FprDataGridProps> = ({ areaCode, dataSource }) => {
  const data = useMemo(
    () =>
      areaCode
        ? dataSource.filter((o) => o.damageAreaCode === areaCode)
        : dataSource,
    [areaCode, dataSource],
  );

  const columns: CustomColumns<InspectionDamage> = useMemo(
    () => [
      { dataIndex: 'id', title: 'ID' },
      { dataIndex: 'damageAreaDesc', title: 'Area' },
      { dataIndex: 'damagePartDesc', title: 'Part' },
      { dataIndex: 'damageTypeDesc', title: 'Type' },
      { dataIndex: 'damageCauseDesc', title: 'Cause' },
      { dataIndex: 'severityDesc', title: 'Severity' },
      { dataIndex: 'note', title: 'Note' },
    ],
    [],
  );
  return (
    <CustomTable
      dataSource={data}
      columns={columns}
      rowKey="id"
      pagination={dataSource.length > 10 ? undefined : false}
    />
  );
};
